<template>
    <div class="business-fundamentals row">
        <div class="col-default-7 col-v-tablet-12">
            <scheme @input="changeItem" :value="item"/>
        </div>
        <div class="col-default-5 col-v-tablet-12">
            <div class="business-fundamentals__description">
                <div class="business-fundamentals__name" v-html="data[item] ? data[item].name : ''"></div>
                <div class="business-fundamentals__title" v-if="data[item] && data[item].title" v-html="data[item] ? data[item].title : ''"></div>
                <z-list tag="ul" v-if="data[item] && data[item].items">
                    <z-list-item v-for="(item, idx) in data[item].items" :key="idx" v-html="item" />
                </z-list>
            </div>
        </div>
    </div>
</template>

<script>
import scheme from './components/scheme.vue'

export default {
    name: 'business-fundamentals',
    components: {
        scheme
    },
    props: {
        data: {
            type: Object
        },
        default: {
            type: String
        }
    },
    data () {
        return {
            item: this.default
        }
    },
    methods: {
        changeItem (item) {
            this.item = item
        }
    }
}
</script>

<style lang="scss">

.business-fundamentals {
    &__name {
        font-weight: 500;
        font-size: 32px;
        line-height: 150%;
        color: $token-colors-black-80;
        @include margin-level(bottom, XS);
    }

    &__title {
        font-weight: 500;
        font-size: 20px;
        line-height: 140%;
        color: $token-colors-black-80;
        @include margin-level(bottom, XS);
    }
}
</style>
